import appConfig from 'src/config'
import {
  AccessTokenKey,
  AccessTokenExpirationKey,
  RefreshTokenKey,
} from 'src/constants/localStorageKeys'

export const updateTokens = ({
  accessToken,
  expiration,
  refreshToken,
}: {
  accessToken: string
  expiration: string
  refreshToken: string
}) => {
  localStorage.setItem(AccessTokenKey, accessToken)
  localStorage.setItem(AccessTokenExpirationKey, expiration)
  localStorage.setItem(RefreshTokenKey, refreshToken)
}

const getExpirationFromNow = (expiresIn: string) => {
  const now = new Date()
  return new Date(
    now.setSeconds(now.getSeconds() + Number(expiresIn))
  ).toUTCString()
}

const refreshAuth = async () => {
  const tokenExpiration = localStorage.getItem(AccessTokenExpirationKey)

  if (tokenExpiration) {
    if (new Date(tokenExpiration) < new Date()) {
      const refreshToken = localStorage.getItem(RefreshTokenKey)
      if (refreshToken) {
        const refreshTokenResponse = await fetch(
          `https://securetoken.googleapis.com/v1/token?key=${appConfig.FIREBASE_API_KEY}`,
          {
            method: 'POST',
            headers: { 'Content-type': 'application/x-www-form-urlencoded' },
            body: `grant_type=refresh_token&refresh_token=${refreshToken}`,
          }
        )
        if (refreshTokenResponse.ok) {
          const refreshTokenData = await refreshTokenResponse.json()

          const expiration = getExpirationFromNow(
            refreshTokenData['expires_in']
          )

          // update token, refresh token & token expiration in localStorage
          updateTokens({
            accessToken: refreshTokenData['id_token'],
            refreshToken: refreshTokenData['refresh_token'],
            expiration,
          })
        }
      }
    }
  }
}

const defaultHeaders = { 'content-type': 'application/json' }

interface RequestOptions extends RequestInit {
  body?: any
}

/**
 * Fetch wrapper for handling requests to API
 * @param endpoint: string
 * @param options: {}
 */
export const client = async (endpoint: string, options?: RequestOptions) => {
  await refreshAuth()

  const token = window.localStorage.getItem(AccessTokenKey)

  const baseHeaders = { ...defaultHeaders, ...options?.headers }

  const headers = new Headers(
    token
      ? {
          Authorization: `Bearer ${token}`,
          ...baseHeaders,
        }
      : baseHeaders
  )

  const config: RequestInit = {
    method: options?.body ? 'POST' : 'GET',
    ...options,
    headers,
  }

  if (options?.body) {
    config.body = JSON.stringify(options?.body)
  }

  const response = await fetch(endpoint, { ...config })

  const data = await response.json()

  if (response.ok) {
    return data
  }

  return await Promise.reject(data)
}
